import { globalLogger } from './global-logger';
import { pageNotification } from './notify';
import { testIsObject, testIsUndefined, testObjectHasKey } from '../../lib/test-and-assert/test-base';
import { projectHelper } from '../../lib-sat/misc/project-helper';
import { userManager } from '../../lib-sat/user/user-manager';
import { useResultPageStore } from "../modules/sat/components/result_v2/stores/ResultPageStore.js";

let countries = [
    'AT',
    'BE',
    'HR',
    'BG',
    'CY',
    'CZ',
    'DK',
    'EE',
    'FI',
    'FR',
    'DE',
    'GR',
    'HU',
    'IE',
    'IT',
    'LV',
    'LT',
    'LU',
    'MT',
    'NL',
    'PL',
    'PT',
    'RO',
    'SK',
    'SI',
    'ES',
    'SE',
    'GB',
];

let init = async function () {

    if (sessionStorage.getItem('PLAYWRIGHT') === 'true') {
        return;
    }

    if (window.sat.disableOneTap) {
        return;
    }

    if (window.satConnectionType === 'slow') {
        return;
    }

    const url = new URL(window.location.href);

    // from MDN https://developer.mozilla.org/en-US/docs/Web/API/URL/pathname
    // The pathname property of the URL interface is a USVString containing an initial '/' followed
    // by the path of the url NOT including the query string or fragment (or the empty string if
    // there is no path).
    const path = url.pathname;

    var excludeResult = false;

    if (path.includes('result') === true) {
        excludeResult = true;
        let store     = useResultPageStore();

        if (store.resultPage.jobs) {
            let jobState = store.resultPage.jobs[0]?.state;

            while (jobState === 'processing') {
                await new Promise(resolve => setTimeout(resolve, 500));
                jobState = store.resultPage.jobs[0]?.state;
            }

            if (jobState === 'unauthorized') {
                excludeResult = false;
            }
        }
    }

    if (
        path.includes('/reset-password') || 
        path.includes('/register') || 
        path.includes('/ai-creator-studio') ||
        excludeResult
    ) {
        return;
    }
    
    // onetap should be disabled on all editor pages like:
    // https://www.pdf2go.com/merge-pdf/editor#j=359c4b22-...
    // if a user logs in via one tap on those pages then the conversion can't be started because the user changed
    if (path.endsWith('/editor')) {
        return;
    }

    try {
        const user = await userManager.getUser();
        if (user.isRegistered() !== false) {
            return;
        }

        let cookieValue = window.qgCookieHelper.getCookieValue('qg_consent');

        // do not show onetap if consent is shown
        if (countries.includes(user.country) && cookieValue === null) {
            return;
        }

        loadOneTap();
    } catch (e) {
        globalLogger.log('onetap get user fail');
        pageNotification.warning('Sorry, something went wrong. Please try again, or refresh the page.');
    }
};

function initOneTapAfterLoading() {
    if (
        testIsUndefined(window.google) ||
        !testIsObject(window.google) ||
        !testObjectHasKey(window.google, 'accounts')
    ) {
        globalLogger.log('onetap load client fail');
        return;
    }

    window.google.accounts.id.initialize({
        client_id: window.sat.googleClientId,
        callback: function (response) {
            if (response.credential) {
                globalLogger.log('Perform login');
                performLogin(response.credential);
            } else {
                globalLogger.log('Identity Services error: No credential returned');
            }
        },
    });

    window.google.accounts.id.prompt((notification) => {
        if (notification.isNotDisplayed()) {
            let reason = notification.getNotDisplayedReason();
            globalLogger.log('onetap notification notdisplayed ' + reason);
        }

        if (notification.isSkippedMoment()) {
            let reason = notification.getSkippedReason();
            globalLogger.log('onetap notification skipped ' + reason);
        }

        let moment = notification.getMomentType();
        globalLogger.log('onetap notification moment ' + moment);

        if (notification.isDismissedMoment()) {
            let reason = notification.getDismissedReason();
            globalLogger.log('onetap notification dismissed ' + reason);
        }
    });
}

let loadOneTap = function () {
    $.ajaxSetup({ cache: true });

    $.getScript('https://accounts.google.com/gsi/client')
        .done(function (script, textStatus) {
            const startS = Date.now() / 1000;

            function waitForOneTap() {
                const nowS = Date.now() / 1000;

                if (nowS - startS > 10) {
                    globalLogger.log('onetap load client fail - timeout');

                    return;
                }

                if (testIsUndefined(window.google)) {
                    setTimeout(waitForOneTap, 1000);

                    return;
                }

                initOneTapAfterLoading();
            }

            waitForOneTap();
        })
        .fail(function (jqXHR, textStatus, errorThrown) {
            globalLogger.log('onetap load client fail');
            pageNotification.warning('Sorry, something went wrong. Please try again, or refresh the page.');
        });
};

let performLogin = function (accessToken) {
    var options = {
        url: sat.apiUrl + '/api/user/login',
        xhrFields: {
            withCredentials: true,
        },
        data: {
            _google_token: accessToken,
        },
    };

    pageNotification.info('Please wait while we log you in...');

    $.post(options)
        .done(function (a) {
            if (a.message === 'success') {
                globalLogger.log('onetap login success');
                window.location.reload();
            } else {
                let so = '';
                if (a.hasOwnProperty('so')) {
                    so = a.so;
                }
                globalLogger.log('onetap login redirect register');
                window.location.href = sat.registerUrl + '#so=' + so;
            }
        })
        .fail(function (jqXHR, textStatus, errorThrown) {
            globalLogger.log('onetap login fail');
            pageNotification.warning('Sorry, something went wrong. Please try again, or refresh the page.');
        });
};

$(window).on('load', function () {
    init();
});
